<template>
  <div v-if="news.length > 0" class="landing_slider">
    <div class="landing_slider_title">
      Recent <b>News</b>
    </div>
    <div id="view-news" ref="news_slider" class="news_container">
      <div v-for="n in news" :key="n.id" class="news-card">
        <div :id="'recent-news-' + n.id" class="community_event article">
          <div class="left-card">
            <a class="community_event_bg" :href="n.news_url">
              <img :data-src="n.metadata_image" width="375" height="158" style="max-height: 158px; object-fit: cover;" class="lazyload" @error="replaceEventCardBackgroundDefault">
            </a>
            <div class="community_event_info">
              <a class="community_event_author"><span class="author_name">{{ n.author }}</span> | <span class="community_event_author_date">{{ n.news_date }}</span></a>
              <a class="community_event_title left_event_title" :title="n.news_url" :href="n.news_url">{{ n.text_title }}</a>
              <div class="community_event_desc">
                <div class="community_event_desc_line">
                  {{ n.description }}
                </div>
              </div>
              <div class="community_event_bar" />
              <a class="community_event_link" :href="n.news_url" target="_blank">View Article</a>
              <div class="community_event_bar_2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { helper } from '../../../mixins/helper';
import { LandingAPI } from '../../../api/landing';
import Vue from 'vue';
import 'slick-carousel/slick/slick.min';
import jQuery from 'jquery';

const SLICK_RESPONSIVE_CONFIG_NEWS = [
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

export default {
  mixins: [component, LandingAPI, helper],
  data() {
    return {
      news: [],
      pagination: {
        page: 1,
        running: false,
        limit: 6,
      },
    };
  },
  created() {
    this.getRecentNews();
  },
  methods: {
    async getRecentNews() {
      const newses = await this.getListRecentNewsAPI();
      const newsesIds = {};
      this.news = newses.filter(news => {
        return newsesIds[news.id] ? false : (newsesIds[news.id] = true);
      });
      Vue.nextTick(() => {
        this.initCarousel();
      });
    },
    initCarousel() {
      jQuery(this.$refs.news_slider).slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        variableWidth: true,
        initialSlide: 0,
        draggable: false,
        responsive: SLICK_RESPONSIVE_CONFIG_NEWS,
      });
      this.initCarouselLoadMore();
    },
    initCarouselLoadMore() {
      jQuery(this.$refs.news_slider).on('afterChange', (event, slick, currentSlide) => {
        const elem = jQuery(this.$refs.news_slider);
        const slidesToShow = slick.slickGetOption('slidesToShow');
        const slideCount = this.news.length;
        if (currentSlide >= slideCount - slidesToShow) {
          if (!this.pagination.running) {
            this.pagination.running = true;
            const url = this.appConfig.baseUrl + '/api/get-recent-news?page=' + (this.pagination.page + 1) + '&limit=' + this.pagination.limit;
            elem.find('.slick-next').first().addClass('btn_slick_disable');
            this.$http.get(url)
              .then(response => {
                this.pagination.running = false;
                if (response.data.content.length === 0) {
                  elem.off('afterChange');
                  elem.find('.slick-next').first().addClass('btn_slick_disable');
                  elem.on('afterChange', (event, slick, currentSlide) => {
                    if (currentSlide > slideCount - slidesToShow - 1) {
                      elem.find('.slick-next').first().addClass('btn_slick_disable');
                    } else {
                      elem.find('.slick-next').first().removeClass('btn_slick_disable');
                    }
                  });
                } else {
                  this.destroyCarousel();
                  for (let i = 0; i < response.data.content.length; i++) {
                    this.news.push(response.data.content[i]);
                  }
                  this.pagination.page++;
                  Vue.nextTick(() => {
                    this.initCarousel();
                    jQuery(this.$refs.news_slider).slick('slickGoTo', currentSlide, true);
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.pagination.running = false;
              })
              .finally(() => {
                this.pagination.running = false;
              });
          }
        }
        return true;
        // }
      });
    },
    destroyCarousel() {
      jQuery(this.$refs.news_slider).off('afterChange');
      jQuery(this.$refs.news_slider).slick('unslick');
    },
  },
};
</script>
